export default __webpack_public_path__ + "d37e6c4015ce7d7fbb43a94e34d9f324.svg";